import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { SiparisKalemiEditComponent } from './siparis-kalemi-edit.component';
import { SiparisKalemiKartComponent } from './siparis-kalemi-kart.component';

@DinamikBilesen({
  id: 'siparis-kalemi',
  baslik: 'Sipariş Kalemi',
  aciklama: 'Sipariş kalemi ekle',
  ikon: 'shopping-cart',
  kategori: 'satis',
})
class SiparisKalemi {
  paylas_kutusu = SiparisKalemiEditComponent;
  paylasilmis_kart = SiparisKalemiKartComponent;
}
